export const propertyNames = {
  STORE_ID: 'storeID',
  STORE_IDS: 'storeIDs',
  ADD_TO_REPAIR: `addToRepair`,
  CUSTOMER_ID: 'customerID',
  CALCULATE_RETAIL_PRICE: 'calculateRetailPrice',
  PRODUCT_ID: 'productID',
  CATALOG_ID: 'catalogID',
  ITEM_GROUP_IDS: 'itemGroupIDs',
  HIDE_UNAVAILABLE_ITEMS: 'hideUnavailableItems',
  SORT_BY_PRICE: 'sortByPrice',
  PRICE: 'price',
  ORDER_CODE: 'orderCode',
  ORDER_STATUS_CODE: 'orderStatusCode',
  HIDE_CLOSED_CONSIGNMENTS: 'hideClosedConsignments',
  INVOICE_CODE: 'InvoiceCode',
  INVOICE_ID: 'InvoiceID',
  USE_RETAIL_PRICES: 'useRetailPrices',
  EXCHANGE_RATE: 'exchangeRate',
  JOB_TYPE_CODE: 'jobTypeCode',
  REGISTER_ID: 'registerID',
  INVENTORY_TRANSFER_CODE: 'inventoryTransferCode',
  SOURCE_STORE_ID : 'sourceStoreID',
  DESTINATION_STORE_ID : 'destinationStoreID',
  STATUS_CODE: 'statusCode',
  FROM_DATE: 'fromDate',
  TO_DATE: 'toDate',
  ITEM_GROUP_ID: 'itemGroupID',
  ITEM_TYPE_ID: 'itemTypeID',
  LOCATION_ID: 'locationID',
  USER_REQUEST: 'userRequest',
  IN_PROGRESS_SERVICE_ID: 'inProgressServiceID',
  SALES_REP_ID: 'salesRepID',
  SENT_BY: 'sentBy',
  COUNTRY_ID: 'countryID',
  STATE_ID: 'stateID',
  CITY: 'city',
  NAME: 'name',
  EMAIL_ADDRESS: 'emailAddress',
  PHONE_NUMBER: 'phoneNumber',
  CUSTOMER_TYPE_ID: 'customerTypeID',
  PERIOD: 'period',
  ITEM_TYPE_IDS: 'itemTypeIDs',
  REPAIR_NO: 'repairNo',
  CUSTOMER_IDS: 'customerIDs',
  MEMO2: 'memo2',
  DATE_FROM: 'DateFrom',
  DATE_TO: 'DateTo',
  PRODUCT_CATALOG_ID : 'productCatalogID',
  SPACE: 'space',
  FROM_DUE_DATE: 'fromDueDate',
  TO_DUE_DATE: 'toDueDate',
  SALES_PERSON_IDS: 'salesPersonIDs',
  ITEM_TYPE_SKU: 'itemTypeSKU',
  JOB_SUBTYPE_CODE: 'jobSubTypeCode',
  SALE_NUMBER: 'saleNumber',
  CREATE_DATE_FROM: 'createDateFrom',
  CREATE_DATE_TO: 'createDateTo',
  HIDE_PAID_INVOICES: 'hidePaidInvoices',
  CONSIGNMENT_CODE: 'consignmentCode',
  USE_MONTH: 'useMonth',
  DAYS: 'days',
  MONTH: 'month',
  UNPAID: 'unPaid',
  ITEM_TYPE_NAME: 'itemTypeName',
  ITEM_SKU: 'itemSKU',
  REFERENCE: 'reference',
  METAL_ITEM_TYPE_IDs: 'metalItemTypeIDs',
  SHOW_VARIANTS: 'showVariants',
}
